<div class="pedido-itens-detalhe" *ngIf="produto">

  <!-- Cabeçalho: nome / código / categoria + badges de trava/tabela especial -->
  <div class="pedido-itens-detalhe-cabecalho">
    <div>
      <div class="pedido-itens-detalhe-titulo">{{ produto.name }}</div>
      <div class="pedido-itens-detalhe-sub">
        Código: {{ produto.codigo }} <span *ngIf="produto.categoria">&nbsp;|&nbsp; Categoria: {{ produto.categoria }}</span>
      </div>
    </div>
    <div class="pedido-itens-detalhe-badges">
      <span class="badge badge-warning" *ngIf="+produto.promocao === 1">Promoção</span>
      <span class="pedido-itens-badge pedido-itens-badge-info" *ngIf="ehPrecoTravado(produto)">
        {{ labelPrecoTravado }}
        <button type="button" class="close" aria-label="Remover trava"
          (click)="$event.stopPropagation(); travaRemovida.emit(produto.id)">&times;</button>
      </span>
      <span class="pedido-itens-badge pedido-itens-badge-neutro" *ngIf="produto['ignorar_pontuacao_por_tabela']"
        title="Tabela especial: fator financeiro não aplicado no preço nem na pontuação">
        Sem fator fin. (tabela)
      </span>
    </div>
  </div>

  <!-- Ações (movido pra cima do painel, logo abaixo do cabeçalho — pedido do usuário: os
       botões de Fotos/Informações/Estoque Local/Tabelas ficavam no fim do painel, exigindo
       rolagem pra alcançar; nenhuma lógica muda, só a posição no template). -->
  <div class="pedido-itens-detalhe-acoes">
    <button type="button" class="btn btn-sm btn-outline-secondary" title="Fotos"
      (click)="abrirFotos.emit({ content: modalFotos, id_produto: produto.id })">
      <i class="fa fa-image"></i> Fotos
    </button>
    <button type="button" class="btn btn-sm btn-outline-secondary" title="Informações"
      (click)="abrirInformacoes.emit({ content: modalInformacoes, id_produto: produto.id })">
      <i class="fa fa-info"></i> Informações
    </button>
    <button type="button" class="btn btn-sm btn-outline-secondary" title="Estoque Local"
      (click)="abrirEstoqueLocal.emit({ content: modalEstoqueLocal, id_produto: produto.id })">
      <i class="fa fa-map"></i> Estoque local
    </button>
    <button type="button" class="btn btn-sm btn-outline-secondary" title="Tabelas"
      (click)="abrirTabelas.emit({ content: modalTabelas, id_produto: produto.id, id_lote: produto.id_lote })">
      <i class="fa fa-list"></i> Tabelas
    </button>
  </div>

  <!-- Contexto: estoque / fracionado / validade do lote / limites de desconto -->
  <div class="pedido-itens-detalhe-contexto">
    <div class="pedido-itens-box" *ngIf="produto.qtde_lote == 0 && produto.estoque != null">
      <div class="label">Estoque</div>
      <div [ngClass]="{ 'text-danger': produto.estoque === 0 }">{{ produto.estoque }}</div>
    </div>
    <div class="pedido-itens-box" *ngIf="produto.qtde_lote > 0 && produto.id_lote != null && produto.estoque_lote != null">
      <div class="label">Estoque</div>
      <div [ngClass]="{ 'text-danger': produto.estoque_lote === 0 }">{{ produto.estoque_lote }}</div>
    </div>
    <div class="pedido-itens-box" *ngIf="produto.fracionado && produto.estoque_fracionado != null && produto.estoque != null">
      <div class="label">Fracionado</div>
      <div>{{ produto.estoque }} / {{ produto.valorunidade }} = {{ produto.estoque_fracionado }}</div>
    </div>
    <div class="pedido-itens-box" *ngIf="produto.qtde_lote > 0 && produto.id_lote != null && produto.validade_lote != null">
      <div class="label">Validade</div>
      <div>{{ produto.validade_lote | date: 'dd/MM/yyyy' }}</div>
    </div>
    <div class="pedido-itens-box" *ngIf="(produto.desc_manager || produto.desc_master || produto.desc_maximo)">
      <div class="label">Limites de desconto</div>
      <div class="pedido-itens-desconto-limites">
        <span *ngIf="produto.desc_manager != null && produto.desc_manager != 0" class="pedido-itens-desconto-link"
          (click)="descontoSelecionado.emit({ id_produto: produto.id, po_desconto: produto.desc_manager })">
          Sugerido: {{ produto.desc_manager | currency: 'BRL' : '' }}%
        </span>
        <span *ngIf="produto.desc_master != null && produto.desc_master != 0" class="pedido-itens-desconto-link"
          (click)="descontoSelecionado.emit({ id_produto: produto.id, po_desconto: produto.desc_master })">
          Máximo: {{ produto.desc_master | currency: 'BRL' : '' }}%
        </span>
        <span *ngIf="produto.desc_maximo != null && produto.desc_maximo != 0" class="pedido-itens-desconto-link"
          (click)="descontoSelecionado.emit({ id_produto: produto.id, po_desconto: produto.desc_maximo })">
          Exceção: {{ produto.desc_maximo | currency: 'BRL' : '' }}%
        </span>
      </div>
    </div>

  </div>
  <section class="pedido-itens-historico" *ngIf="produto.ultima_compra != null">
    <h3>Última compra</h3>
    <div class="pedido-itens-historico-linha">
    <!-- Última Compra (requisito extra da Task 5: html original:1112-1132, não coberto por
         nenhum dos dois componentes filhos até aqui — ver task-5-brief.md). Somente leitura. -->
    <div class="pedido-itens-box" *ngIf="produto.ultima_compra != null">
      <div class="label">Data</div>
      <div>{{ produto.ultima_compra | date: 'dd/MM/yyyy' }}</div>
    </div>
    <div class="pedido-itens-box" *ngIf="produto.ultima_compra != null">
      <div class="label">Qtde.</div>
      <div>{{ produto.qtd_faturada != null && produto.qtd_faturada != 0 ? produto.qtd_faturada : produto.quantity }}</div>
    </div>
    <div class="pedido-itens-box" *ngIf="produto.ultima_compra != null">
      <div class="label">Unitário</div>
      <div>{{ (produto.preco_faturado != null && produto.preco_faturado != 0 ? produto.preco_faturado : produto.unit_price) | currency: 'BRL' }}</div>
    </div>
    <div class="pedido-itens-box" *ngIf="produto.ultima_compra != null">
      <div class="label">Desconto</div>
      <div *ngIf="configuracao != null && !configuracao.exibe_price_como_tabela_pedidos">{{ produto.desc_aplicado | currency: 'BRL' : '' }}%</div>
      <div *ngIf="configuracao != null && configuracao.exibe_price_como_tabela_pedidos">{{ produto.desc_aplicado2 | currency: 'BRL' : '' }}%</div>
    </div>
  </div>

  </section>

  <h3 class="pedido-itens-secao-titulo">Referência de preços</h3>
  <div class="pedido-itens-referencia">
    <table class="pedido-itens-precos-table" aria-label="Referência de preços">
      <thead><tr><th scope="col">Preço</th><th scope="col">{{ aplicaFatorReferencia ? 'Sem fator' : 'Valor' }}</th>
        @if (aplicaFatorReferencia) { <th scope="col">Com fator</th><th scope="col">Fator financeiro</th> }
      </tr></thead>
      <tbody>
        @if (produto.qtde_lote == 0) {
          <tr><th scope="row">Tabela</th><td>
            @if (aplicaFatorReferencia) { {{ formatarValoresQuatroCasasDecimais(produto.price) }} }
            @else { <button type="button" class="pedido-itens-preco-botao" (click)="valorTabelaSelecionado.emit({ id_produto: produto.id, preco_unitario: produto.price })">{{ formatarValoresQuatroCasasDecimais(produto.price) }}</button> }
          </td>
          @if (aplicaFatorReferencia) {
            <td><button type="button" class="pedido-itens-preco-botao" (click)="valorComFatorSelecionado.emit({ id_produto: produto.id, valorJaFatorado: exibirPontuacao ? produto.price * (1 + prazoPagamentoSelecionado.fator_financeiro / 100) : produto.valor_fator_financeiro_tabela })">{{ formatarValoresQuatroCasasDecimais(exibirPontuacao ? produto.price * (1 + prazoPagamentoSelecionado.fator_financeiro / 100) : produto.valor_fator_financeiro_tabela) }}</button></td>
            <td class="pedido-itens-fator-resumo" rowspan="2"><div>Percentual: {{ produto.porcentagem_fator_inicial | number: '1.2-2' }}%</div><div>Valor: {{ produto.valor_fator_financeiro_inicial | currency: 'BRL' }}</div></td>
          }
          </tr>
          @if (produto.fracionado || aplicaFatorReferencia) {
            <tr><th scope="row">Fracionado</th><td>@if (produto.fracionado) { {{ formatarValoresQuatroCasasDecimais(precoFracionadoReferencia(produto)) }} } @else { — }</td>
              @if (aplicaFatorReferencia) { <td class="pedido-itens-preco-destaque">{{ formatarValoresQuatroCasasDecimais(precoFracionadoComFatorReferencia(produto)) }}</td> }
            </tr>
          }
        }
        @if (produto.qtde_lote > 0 && produto.id_lote != null) {
          <tr><th scope="row">Tabela (lote)</th><td><button type="button" class="pedido-itens-preco-botao" (click)="valorLoteSelecionado.emit({ id_produto: produto.id, preco_lote: produto.preco_lote })">{{ produto.preco_lote | currency: 'BRL' }}</button></td></tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Adicionar item -->
  <div class="pedido-itens-config-item">
    <div class="label">Adicionar Item</div>
    <div class="pedido-itens-config-linha">

      <!-- Lote -->
      <div class="pedido-itens-campo" *ngIf="produto.qtde_lote > 0">
        <label>
          Lote
          <i class="fa fa-search-plus pedido-itens-acao-inline" title="Selecionar"
            (click)="abrirLotes.emit({ content: modalLotes, id_produto: produto.id })"></i>
          <i class="fa fa-times pedido-itens-acao-inline" title="Remover" *ngIf="produto.id_lote != null"
            (click)="loteRemovido.emit(produto.id)"></i>
        </label>
        <input type="text" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': produto.erro_lote }"
          [ngModel]="produto.nome_lote" disabled>
        <app-pedido-itens-erro-inline [mensagem]="produto.erro_lote ? 'Lote inválido!' : null"></app-pedido-itens-erro-inline>
      </div>

      <!-- Quantidade -->
      <div class="pedido-itens-campo">
        <label>Qtde</label>
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <button class="btn btn-outline-secondary" type="button" (click)="qtdeDecrementada.emit(produto.id)">-</button>
          </div>
          <input type="number" min="1" step="1" class="form-control" [(ngModel)]="produto.qtde"
            [ngClass]="{ 'is-invalid': produto.erro_qtde }"
            [disabled]="produto.id_kit_combo != null || (produto.qtde_lote > 0 && produto.id_lote == null) || calculando"
            (input)="qtdeAlterada.emit({ id_produto: produto.id, foco: false, event: $event })"
            (focusout)="qtdeAlterada.emit({ id_produto: produto.id, foco: true, event: $event })">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" (click)="qtdeIncrementada.emit(produto.id)">+</button>
          </div>
        </div>
        <div class="pedido-itens-aviso" *ngIf="(tiposPedidoSelecionado != null && tiposPedidoSelecionado.flag_considerar_pedido_como_venda) && (produto.multiplo != null && produto.multiplo != 0 && produto.multiplo != 1)">
          Múltipla de {{ produto.multiplo }}...
        </div>
        <div class="pedido-itens-aviso" *ngIf="produto['qtde_minima_tabela'] != null && produto['qtde_minima_tabela'] > 0">
          Mín. tabela: {{ produto['qtde_minima_tabela'] }}
        </div>
        <app-pedido-itens-erro-inline [mensagem]="mensagemErroQtde(produto)"></app-pedido-itens-erro-inline>
      </div>

      <!-- Unitário -->
      <div class="pedido-itens-campo">
        <label>Unitário: R$</label>
        <input type="number" min="0" step="0.01" class="form-control form-control-sm" [(ngModel)]="produto.valor"
          [ngClass]="{ 'is-invalid': produto.erro_valor }"
          [disabled]="produto.id_kit_combo != null || (produto.qtde_lote > 0 && produto.id_lote == null) || calculando || ehPrecoTravado(produto)"
          (focus)="edicaoValorIniciada.emit(produto.id)"
          (focusout)="valorValidado.emit({ id_produto: produto.id, foco: true, event: $event })"
          (input)="valorDigitado.emit(produto.id)">
        <div class="pedido-itens-aviso">{{ formatarValoresQuatroCasasDecimais(produto.valor_unitario_fracionado) }}</div>
        <app-pedido-itens-erro-inline [mensagem]="produto.erro_valor ? 'Valor inválido ou abaixo do desconto máximo permitido!' : null"></app-pedido-itens-erro-inline>
      </div>

      <!-- Desconto -->
      <div class="pedido-itens-campo">
        <label>Desconto: %</label>
        <input type="number" min="0" step="0.01" class="form-control form-control-sm" [(ngModel)]="produto.porcentagem_desconto_temporaria"
          [disabled]="produto.id_kit_combo != null || (produto.qtde_lote > 0 && produto.id_lote == null) || calculando || ehPrecoTravado(produto)"
          (focus)="descontoTemporarioDefinido.emit(produto.porcentagem_desconto_temporaria); edicaoDescontoIniciada.emit(produto.id)"
          (focusout)="edicaoDescontoFinalizada.emit({ id_produto: produto.id, event: $event })"
          (input)="descontoUnitarioCalculado.emit({ id_produto: produto.id, alterar: true, adicionado: false })">
      </div>

      <!-- Pontuação -->
      <div class="pedido-itens-campo" *ngIf="exibirPontuacao && produto.pontuacao != null && produto.pontuacao > 0">
        <label>Pontuação</label>
        <input type="number" class="form-control form-control-sm" [value]="produto.pontuacao_calculada" disabled>
      </div>

      <!-- Fator: % / R$ (somente leitura) -->
      <div class="pedido-itens-campo" *ngIf="configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null">
        <label>Fator: %</label>
        <input type="number" class="form-control form-control-sm" [ngModel]="produto.porcentagem_fator_inicial" disabled>
      </div>
      <div class="pedido-itens-campo" *ngIf="configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null">
        <label>Fator: R$</label>
        <input type="number" step="0.01" class="form-control form-control-sm" [ngModel]="fatorFinanceiroExibido" disabled>
      </div>

      <!-- C/ Imposto -->
      <div class="pedido-itens-campo" *ngIf="configuracao != null && configuracao.flag_exibir_imposto_produto">
        <label>C/ Imposto: R$</label>
        <input type="number" class="form-control form-control-sm" [value]="produto.valor_imposto_produto" disabled>
        <div class="pedido-itens-aviso">{{ formatarValoresQuatroCasasDecimais(produto.valor_unitario_imposto_fracionado) }}</div>
      </div>

      <!-- Qtde (Bonificada) -->
      <div class="pedido-itens-campo" *ngIf="!exibirPontuacao && pedido == null && tiposPedidoSelecionado != null && tiposPedidoSelecionado.flag_considerar_pedido_como_venda">
        <label>Qtde: (Bonificada)</label>
        <input type="number" min="1" step="1" class="form-control form-control-sm" [(ngModel)]="produto.qtde_bonificada"
          [ngClass]="{ 'is-invalid': produto.erro_qtde }"
          [disabled]="produto.id_kit_combo != null || (produto.qtde_lote > 0 && produto.id_lote == null) || calculando"
          (focusout)="qtdeAlterada.emit({ id_produto: produto.id, foco: true, event: $event })">
        <app-pedido-itens-erro-inline [mensagem]="produto.erro_qtde ? 'Qtde inválida!' : null"></app-pedido-itens-erro-inline>
      </div>
    </div>

    <!-- Observação -->
    <div class="pedido-itens-campo pedido-itens-campo-full" *ngIf="configuracao != null && configuracao.flag_exibe_observacao_item_pedido && produto.categoria != campanhas">
      <label>Observação</label>
      <textarea class="form-control form-control-sm" rows="1" maxlength="500" [(ngModel)]="produto.observacao_item"></textarea>
    </div>
  </div>
</div>
